import React from 'react';

const Spa = () => {
  return (
    <div className="container">
      <section>
      <div id="senderismoCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-inner rounded shadow">
          <div className="carousel-item active">
            <img src="/spa.jpeg" className="d-block w-100" alt="Eco Cabaña" style={{height: '600px', objectFit: 'cover'}} />
          </div>
        </div>
      </div>
      </section>
      <section>
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 text-success mb-3">Spa</h1>
          <p className="lead mb-5 text-center">Relaja tu cuerpo y experimenta un extasis sensorial en medio del bosque seco tropical.</p>
        </div>
      </div>
      </section>
    </div>
  );
};

export default Spa;